<template>
  <div
    class="toast-container position-fixed bottom-0 end-0 p-3"
    style="z-index: 99"
  >
    <notification-toast
      v-for="toast in toasts"
      :key="`${toast.id}`"
      :message="toast.message"
      :status="toast.status"
      :duration="toast.duration"
      @dismiss="removeToast(toast.id)"
    />
  </div>
</template>

<script>
import NotificationToast from "./NotificationToast.vue";

export default {
  name: "ToastContainer",
  components: { NotificationToast },
  data() {
    return {
      toasts: [],
    };
  },
  methods: {
    showToast({ message, status = 'normal', duration = 3000 }) {
      const id = Date.now() + Math.random();
      this.toasts.push({ id, message, status, duration });
    },
    removeToast(id) {
      this.toasts = this.toasts.filter(toast => toast.id !== id);
    },
  },
};
</script>
